module.exports = __webpack_public_path__ + "static/media/WoodConnectionType3.6e94bfd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WoodConnectionType3.png
// module id = 1188
// module chunks = 0